module.exports = __webpack_public_path__ + "static/media/silver-crown.b9defa88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/silver-crown.png
// module id = 666
// module chunks = 0